import { useState, useEffect } from 'react';

const useTransformedProviders = (data=[], selectedName) => {
    const [transformedData, setTransformedData] = useState(null);

    useEffect(() => {
        if (selectedName && data?.length > 0) {
            const selectedData = data?.find(item => item.name === selectedName);
            if (selectedData) {
                setTransformedData({
                  label: capitalizeFirstLetter(selectedData?.name),
                  value: selectedData?.name,
                  image: selectedData?.image,
                });
            } else {
                setTransformedData(null);
            }
        } else {
            setTransformedData(null);
        }
    }, [data, selectedName]);

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    return {transformedData, setTransformedData};
};

export default useTransformedProviders;
